
import request from "@/services/axios";
import { url } from "@/services/api";
// const url = "http://192.168.88.140:8080"

export default {
  // 根据id在线大屏信息
  getToolBiInfo(params) {
    return request({
      url: url + '/tool/bi/' + params.id,
      method: 'get',
      params: params
    })
  },
  // 在线大屏信息列表查询
  getToolBiQueryPage(params) {
    return request({
      url: url + '/tool/bi/list',
      method: 'get',
      params: params
    })
  },


  // 新增在线大屏信息
  AddToolBi(data) {
    return request({
      url: url + '/tool/bi',
      method: 'post',
      data: data
    })
  },
  // 修改在线大屏信息
  UpdateToolBi(data) {
    return request({
      url: url + '/tool/bi',
      method: 'put',
      data: data
    })
  },
  // 删除在线大屏信息
  DelToolBi(params) {
    return request({
      url: url + '/tool/bi/' + params.id,
      method: 'delete',
    })
  },

}